export default {
  default: {
    remain: {
      en: `
        You\'re <span class="text-gold-50 font-bold">{remain}</span> away from
        <span class="text-gold-50 font-bold">{promoName}</span>
      `,
    },
    earned: {
      en: 'You\'ve earned a <span class="text-gold-50 font-bold">{promoName}</span>',
    },
    description: {
      en: `
        It’s our 10th anniversary, but you get the presents!
        For a limited time, get {promoDescription} on e-commerce purchases of {subTotal} and up.
      `,
    },
    promoName: {
      en: 'free mystery gift'
    },
    promoDescription: {
      en: 'a set packed with 5 scent vials of surprise 1.5 mL best-sellers',
    },
  },
  mothersDay: {
    remain: {
      en: `
        You\'re <span class="text-gold-50 font-bold">{remain}</span> away from
        <span class="text-gold-50 font-bold">{promoName}!</span>
      `,
    },
    earned: {
      en: 'You\'ve earned a <span class="text-gold-50 font-bold">{promoName}/span>',
    },
    description: {
      en: `
        Spend {subTotal} or more and get {promoDescription}.
      `,
    },
    promoName: {
      en: 'FREE GIFT'
    },
    promoDescription: {
      en: 'a 10-piece gift set, featuring a luxe travel bag filled with nine delightful fragrance and beauty samples'
    }
  },
  fathersDay: {
    remain: {
      en: `
        You\'re <span class="text-gold-50 font-bold">{remain}</span> away from
        <span class="text-gold-50 font-bold">{promoName}!</span>
      `,
    },
    earned: {
      en: 'You\'ve earned a <span class="text-gold-50 font-bold">{promoName}</span>',
    },
    description: {
      en: `
        Starting now until June 17, receive {promoDescription} on purchases of {subTotal}+.
      `,
    },
    promoName: {
      en: 'FREE GIFT'
    },
    promoDescription: {
      en: 'a FREE trio of Father’s Day cologne staples in 1.5 ml vials'
    }
  },
}
